module.exports = __webpack_public_path__ + "assets/4SymmetricLinesDetailed.a724582e583349e456a02d6da70b909e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/4SymmetricLinesDetailed.png
// module id = 447
// module chunks = 0